import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ProgressProvider } from './context/ProgressContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import LessonPage from './pages/LessonPage';
import './App.css';

function App() {
  return (
    <ProgressProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/lesson/:slug" element={<LessonPage />} />
            </Routes>
          </main>
          <footer className="footer">
            <div className="footer-content">
              <p>&copy; {new Date().getFullYear()} Ink Drawing for Beginners</p>
            </div>
          </footer>
        </div>
      </Router>
    </ProgressProvider>
  );
}

export default App;
